import { isApiError, isApiValidationError, isValidMessage } from "../guards";
import getFallbackMessage from "./getFallbackMessage";
import getValidationErrorMessage from "./getValidationErrorMessage";
export default function getApiErrorMessage(e) {
    if (!isApiError(e)) {
        return 'Невідома помилка';
    }
    if (isApiValidationError(e)) {
        return getValidationErrorMessage(e);
    }
    if (isValidMessage(e.message)) {
        return e.message;
    }
    return getFallbackMessage(e.type);
}
//# sourceMappingURL=getApiErrorMessage.js.map